import React, { useState } from 'react'
import Navbar from '../Navbar'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBBadge, MDBIcon, MDBCollapse, MDBTooltip } from 'mdbreact'
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import doggo from '../../img/DoogieDoodle.png'
import loving from '../../img/LovingDoodle.png'
import plant from '../../img/PlantDoodle.png'
import Slide from 'react-reveal/Slide'
import SEO from '../SEO';
import TreeCounter from '../TreeCounter';
import FooterWhite from '../FooterWhite';
import Loading from '../loaders/Loading';
import Error from '../loaders/Error';
import ProgressiveImage from 'react-progressive-image'
import Markdown from 'markdown-to-jsx';
//graphql
import { useQuery } from '@apollo/react-hooks';
import ADVOCACY_PAGE_QUERY from '../../queries/pages/advocacyPage';
import SearchModal from './SearchModal';

const Charities = () => {
    const [collapse, setCollapse] = useState(false);
    const [collapse2, setCollapse2] = useState(false);
    const [show, setShow] = useState(false);
    
    const { data, loading, error } = useQuery(ADVOCACY_PAGE_QUERY);

    if(loading) return <Loading/>
    if(error) return <Error/>

    const arrowStyleLeft = {
        background: `#000`,
        padding: `1rem`,
        color: `#fff`,
        position: `absolute`,
        bottom: `-15%`,
        right: `80px`,
        cursor: `pointer`
    }
    const arrowStyleRight = {
        background: `#000`,
        padding: `1rem`,
        color: `#fff`,
        position: `absolute`,
        bottom: `-15%`,
        right: `15px`,
        cursor: `pointer`
    }

    const { Summary_Introduction, Summary_Content, 
        Summary_Carousel, stories, Purpose_Introduction, Purpose_Content, 
        Light_Highlight_Section, Impact_Title, Impact_Content, 
        Impact_Cover, Grey_Highlight_Section, charities
    } = data.advocacyPage

    const summaryImages = Summary_Carousel.map((item)=> 
    <>
    <ProgressiveImage src={item.url} placeholder={item.formats.thumbnail.url}>
       {(src, loading) => (<img style={{ filter: loading && "blur(10px)" }} src={src} alt="" className="w-100"/>)}
    </ProgressiveImage>
    </>
    )

    const storyImages = stories.map((story)=>
        <>
        <MDBCol className="px-0">
            <ProgressiveImage src={story.preview.url} placeholder={story.preview.formats.thumbnail.url}>
                {(src, loading) => (<img className="w-100" style={{ filter: loading && 'blur(10px)' }} src={src} alt=""/>)}
            </ProgressiveImage>
            <div className="container text-center white-text p-4">
                <h6 className="font-weight-bold mb-4 text-uppercase h6-responsive">
                    {story.title}
                </h6>
                <h5 className="h6-responsive">
                   {story.description}
                </h5>
            </div>
        </MDBCol>
        </>
    )

    const impactImages = Impact_Cover.map((item)=> 
        <>
        <MDBCol size="4" className="px-0 d-none d-md-flex d-lg-flex">
            <ProgressiveImage src={item.url} placeholder={item.formats.thumbnail.url}>
                {(src, loading) => (<img className="w-100" style={{ filter: loading && "blur(10px)" }} src={src} alt=""/>)}
            </ProgressiveImage>
        </MDBCol>
        </>
    )

    const singleImpactImage = (
        <MDBCol size="12" className="px-0 d-flex d-md-none d-lg-none">
            <ProgressiveImage src={Impact_Cover[0].url} placeholder={Impact_Cover[0].formats.thumbnail.url}>
                {(src, loading) => (<img className="w-100" style={{ filter: loading && "blur(10px)" }} src={src} alt=""/>)}
            </ProgressiveImage>
        </MDBCol>
    )

    const listCharities = charities.map((charity)=> 
        <>
        <MDBCol key={charity.id} md="2" size="6" lg="2">
            <MDBTooltip domElement tag="div" placement="bottom">
                <div>
                    <ProgressiveImage src={charity.image.url} placeholder={charity.image.formats.thumbnail.url}>
                        {(src, loading) => (<img src={src} style={{ filter: loading && "blur(10px)" }} alt="" className="w-100"/>)}
                    </ProgressiveImage>  
                </div>
                <div>{charity.name}</div>
            </MDBTooltip>
        </MDBCol>   
        </>
    )

    return (
        <>
        <SEO title="Advocacy" description="Talk is cheap, let us show you how Minimuni charitiy works. Our works and our partners. Building a new clean world for our children." />
        <Navbar show={show} onClick={()=>setShow(!show)} page="Advocacy"/>
        <div style={{ display: show ? "none" : "inline" }} className="advocacy-wrapper">
        <Slide bottom cascade>
        <MDBContainer className="mb-5 pb-5">
            <MDBRow className="my-5 py-5">
                <MDBCol md="6" lg="6">
                    <Carousel slidesPerPage={1} infinite addArrowClickHandler arrowLeft={<MDBIcon style={arrowStyleLeft} icon="arrow-left"/>} arrowRight={<MDBIcon style={arrowStyleRight} icon="arrow-right"/>}>
                        {summaryImages}
                    </Carousel>
                </MDBCol>
                <MDBCol md="6" lg="6">
                    <h6 className="h6-responsive font-weight-bold mb-4 mt-5 pt-5 mt-md-0 pt-md-0 mt-lg-0 pt-lg-0 text-uppercase">
                        <MDBBadge color="dark" className="p-2">Our Charity</MDBBadge>
                    </h6>
                    <h4 style={{ lineHeight: `1.4` }} className="h4-responsive mb-4">
                        {Summary_Introduction}
                    </h4>
                    <MDBCollapse isOpen={collapse2}>
                        <h4 className="h4-responsive">
                            {Summary_Content}
                        </h4>
                    </MDBCollapse>
                    <a href="#continue" onClick={()=>setCollapse2(!collapse2)} className="text-capitalize link-underline h5-responsive m-0">
                        {collapse2 ? "Done Reading" : `Continue Reading`} <MDBIcon icon="arrow-right ml-2"/>
                    </a>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
        <section className="py-5 my-5 black white-text">
            <MDBContainer className="my-5 py-5">
                <h6 className="font-weight-bold text-uppercase mb-4">
                    Memorable moments
                </h6>
                <h1 className="h1-responsive mb-5 font-weight-bold">A story that's still being written</h1>
                <div className="d-flex justify-content-between mb-4">
                    <h1 className="font-weight-bold h1-responsive">
                        2020
                    </h1>
                    <h1 className="font-weight-bold h1-responsive">
                        2019
                    </h1>
                    <h1 className="font-weight-bold h1-responsive">
                        2018
                    </h1>
                    <h1 className="font-weight-bold h1-responsive">
                        2017
                    </h1>
                </div>
                <MDBRow>
                    <Carousel breakpoints={{ 
                        240: { slidesPerPage: 1 },
                        260: { slidesPerPage: 1 },
                        290: { slidesPerPage: 1 },
                        300: { slidesPerPage: 1 },
                        325: { slidesPerPage: 1 },
                        360: { slidesPerPage: 1 },
                        420: { slidesPerPage: 1 },
                        460: { slidesPerPage: 1 },
                        520: { slidesPerPage: 1 },
                        560: { slidesPerPage: 1 },
                        620: { slidesPerPage: 1 },
                        768: { slidesPerPage: 3 }, 
                        1024: { slidesPerPage: 3 },
                        1440: { slidesPerPage: 3 }, 
                        1550: { slidesPerPage: 3 },
                        2560: { slidesPerPage: 3 }
                        }} autoPlay={5000} slidesPerPage={1} centered infinite>
                        {storyImages}
                    </Carousel>
                </MDBRow>
            </MDBContainer>
        </section>
        <section className="py-5 my-5">
            <MDBContainer className="my-5 py-5">
                <h1 className="font-weight-bold mb-5 menu-mobile-style display-4">Our Purpose</h1>
                <MDBRow className="my-4">
                    <MDBCol md="8" lg="8">
                        <h3 className="h3-responsive mb-4">
                            {Purpose_Introduction}
                        </h3>
                        <MDBCollapse isOpen={collapse}>
                            <h3 className="h3-responsive mb-4">
                                {Purpose_Content}
                            </h3>
                        </MDBCollapse>
                        <a href="#continue" onClick={()=>setCollapse(!collapse)} className="text-capitalize link-underline h4-responsive m-0">
                            {collapse ? "Done reading" : "Continue Reading"} <MDBIcon icon="arrow-right ml-2"/>
                        </a>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </section>
        <section id="trees" className="py-5 my-5">
            <TreeCounter/>
        </section>
        <section className="py-5 my-5">
            <MDBContainer className="my-5 py-5">
                <MDBRow>
                    <MDBCol md="6" lg="6">
                        <h1 className="display-3 my-4 menu-mobile-style font-weight-bold">
                            {Light_Highlight_Section.title}
                        </h1>
                    </MDBCol>
                    <MDBCol md="6" lg="6">
                        <h3 className="h3-responsive my-4">
                            {Light_Highlight_Section.description}
                        </h3>
                    </MDBCol>
                </MDBRow>
                <MDBRow className="mt-5 text-center">
                    <MDBCol md="12" lg="12">
                        <a href={Light_Highlight_Section.link}>
                            <MDBBtn color="dark" className="text-capitalize m-0">
                                Learn More <MDBIcon fas icon="arrow-right ml-2"/>
                            </MDBBtn>
                        </a>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </section>
        <section>
            <MDBContainer className="py-5 my-5" fluid>
                <MDBRow>
                    {impactImages}
                    {singleImpactImage}
                </MDBRow>
                <div style={{ borderRadius: 0 }} className="card impact-card p-lg-5 p-md-5 p-0 z-depth-0 mx-auto card-w-50">
                    <div className="card-body text-center">
                        <h1 style={{ lineHeight: 4 }} className="font-weight-bold menu-mobile-style h1-responsive text-capitalize">
                            {Impact_Title}
                        </h1>
                        <Markdown
                            options={{
                                overrides: {
                                    h1: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h2: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h3: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h4: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h5: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h6: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    b: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    strong: {
                                        props: {
                                            style: {
                                                fontWeight: '600'
                                            }
                                        }
                                    },
                                    p: {
                                        props: {
                                            className: "lead"
                                        }
                                    },
                                    img: {
                                        props: {
                                            className: "w-responsive"
                                        }
                                    }
                                }
                            }}
                        >
                            {Impact_Content}
                        </Markdown>
                    </div>
                </div>
            </MDBContainer>
        </section>
        <section className="grey lighten-4 py-5" style={{ marginTop: `3rem`, marginBottom: `10%` }}>
        <MDBContainer className="py-5 text-center">
            <MDBRow>
                <MDBCol md="12" lg="12">
                    <h2 style={{ lineHeight: 2 }} className="font-weight-bold h2-responsive">
                        {Grey_Highlight_Section.title}
                    </h2>
                    <p className="lead">
                        {Grey_Highlight_Section.description}
                    </p>
                    <a href={Grey_Highlight_Section.link}>
                        <MDBBtn color="dark" className="text-capitalize">
                            Learn More 
                        </MDBBtn>
                    </a>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
        </section>
        <section>
        <MDBContainer className="my-5 py-5">
            <MDBRow className="mb-5">
                <MDBCol md="12" lg="12">
                    <h1 className="display-4 text-center text-md-left text-lg-left menu-mobile-style font-weight-bold">
                        We at Minimuni Cares
                    </h1>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol md="4" lg="4">
                    <img src={doggo} className="w-100" alt=""/>
                </MDBCol>
                <MDBCol md="4" lg="4">
                    <img src={loving} className="w-100" alt=""/>
                </MDBCol>
                <MDBCol md="4" lg="4">
                    <img src={plant} className="w-100" alt=""/>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
        </section>
        <section className="mt-5 grey lighten-4 py-5">
            <MDBContainer id="partners" className="my-5 py-5">
                <div className="text-center">
                    <h6 style={{ lineHeight: 4 }} className="font-weight-bold text-uppercase">
                        Don't take our word for it
                    </h6>
                    <h2 className="text-capitalize mb-5 font-weight-bold">
                        Our Partners & Charities we support
                    </h2>    
                </div>
                <MDBRow className="partner-img align-items-center justify-content-center">
                    {listCharities}
                </MDBRow>
            </MDBContainer>
        </section>
        </Slide>
        <FooterWhite/>
        </div>
        <SearchModal onClick={()=>setShow(false)} show={show}/>
        </>
    )
}

export default Charities